import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { closeModal, openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const debug = false; // Set to true to enable debugging logs
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector('.header__background');
  if (backgroundContainer) {
    const resizeCallback = throttle(
      () => document.documentElement.style.setProperty('--header-height', `${backgroundContainer.clientHeight}px`),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);

    const announcementBar = document.querySelector('.announcement-bar__background');
    const announcementBarHeight = document.documentElement.style.getPropertyValue('--announcement-bar-height');
    const scrollOffset = announcementBarHeight ? parseInt(announcementBarHeight.replace('px', '')) : 0;

    let lastScrollTop = window.scrollY;
    if (
      typeof backgroundContainer.dataset.transparent !== 'undefined' ||
      typeof backgroundContainer.dataset.expanded !== 'undefined'
    ) {
      let scrollTimeout;

      const scrollCallback = throttle(() => {
        if (sectionContainer.querySelector('.mobile-menu__container.open')) return;

        if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
          const isAtTop = window.scrollY <= scrollOffset;
          backgroundContainer.dataset.transparent = true;
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            if (!isAtTop) {
              backgroundContainer.dataset.transparent = false;
            }
          }, 250);
        }
        if (typeof backgroundContainer.dataset.expanded !== 'undefined') {
          if (debug) console.log('header retractable');

          let currentScroll = window.scrollY;

          if (currentScroll !== 0) {
            backgroundContainer.dataset.expanded = currentScroll < lastScrollTop;
            if (announcementBar && announcementBar.dataset.followHeader === 'true') {
              announcementBar.dataset.expanded = currentScroll < lastScrollTop;
            }
            if (currentScroll < lastScrollTop) {
              if (debug) console.log("Scrolling verso l'alto");
            } else {
              if (debug) console.log('Scrolling verso il basso');
              if (debug) console.log('currentScroll', currentScroll);
              if (debug) console.log('lastScrollTop', lastScrollTop);
            }
          } else {
            backgroundContainer.dataset.expanded = true;
            if (announcementBar && announcementBar.dataset.followHeader === 'true') {
              announcementBar.dataset.expanded = true;
            }
          }

          lastScrollTop = currentScroll;
        }
      }, 200);
      scrollCallback();
      window.addEventListener('scroll', scrollCallback);
    }
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector('.header__action-cart-counter');
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) {
        if (cart.item_count == 0) {
          cartCounter.innerText = '';
        } else {
          cartCounter.innerText = '(' + cart.item_count + ')';
        }
      }
    });
  }

  const searchWrapper = sectionContainer.querySelector('.header__search');
  const searchIcon = sectionContainer.querySelector('.header__action--search');
  if (searchWrapper && searchIcon) {
    const mainInput = searchWrapper.querySelector('input[name="q"]');
    const closeWrapper = searchWrapper.querySelector('.header__search-close');
    if (mainInput && closeWrapper) {
      const closeSearch = () => {
        backgroundContainer.dataset.searchOpen = 'false';
        mainInput.value = '';
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      closeWrapper.addEventListener('click', closeSearch);
      searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        if (backgroundContainer.dataset.searchOpen == 'true') {
          closeSearch();
        } else {
          backgroundContainer.dataset.searchOpen = 'true';
          mainInput.focus();

          const openMobileMenu = sectionContainer.querySelector('.mobile-menu__container');
          if (openMobileMenu) {
            const modal = openMobileMenu.querySelector('.modal');
            openMobileMenu.classList.remove('open');
            closeModal(modal);
          }
        }
      });
    }
  }
};

execOnLoad(window.dAgency.initHeader, '.header__section');
